import { Stack, styled, Typography } from "~/common/mui";
import { ProductEntrySkeleton } from "~/features/addToCart/components/AddToCartProcess/Modals/CartSuccessModal/components/CartSuccessRecommendations/components/ProductEntrySkeleton";

interface Props {
  title: string;
}

export const RecommendationsSkeleton = ({ title }: Props) => {
  return (
    <RecommendedSection>
      <Stack gap={1}>
        <Typography variant="titleMedium">{title}</Typography>

        <ProductEntrySkeleton />
        <ProductEntrySkeleton />
      </Stack>
    </RecommendedSection>
  );
};

const RecommendedSection = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(4),
  [theme.breakpoints.up("tablet")]: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
  },
}));
